import React, { useState } from 'react'
import { useQueryParam } from '../shared/hooks/location'
import { useLoad } from '../shared/hooks/load'
import { useHistory } from 'react-router-dom'
import { useApiFormAuthProvider } from '../api-new/state/auth'
import { useAuthContext } from '../context/auth.context'
import { SignInLinkFailed, SignInLinkSpent, useSignInLinkSpent } from '../shared/sso-workspace/sign-in-link-spent'
import { sendToLinkConfirmation } from '../shared/sso-workspace/link-confirm-api'
import { signInAndRemember, takePendingSignIn } from '../shared/recent-accounts/sign-in-memory'

export const OpenAuth = () => {
  const history = useHistory()

  const authContext = useAuthContext()

  const apiFormAuthProvider = useApiFormAuthProvider()

  const token = useQueryParam('token')
  let redirect = useQueryParam('redirect')
  let redirectDoc = useQueryParam('redirect-doc')

  // A token already used (Back to this page after signing in, a restored
  // tab): into the admin with the session this browser has, else the calm
  // card -- not a blank page.
  const [spent, onSpent] = useSignInLinkSpent()
  // Any other failure: the "didn't work" card, never a blank page.
  const [failed, updateFailed] = useState(null)

  useLoad(async () => {
    try {
      const authToken = await apiFormAuthProvider.get(`${token}/signin`)
      // Recent accounts: the connection the sign-in started with, else
      // single sign-on with no name (sign-in-memory.js).
      signInAndRemember(authContext.setAuthToken, authToken, { method: takePendingSignIn() || { kind: 'sso' } })

      if (redirect) {
        let path = atob(redirect)
        history.replace(path)
        return
      }

      if (redirectDoc) {
        window.location.replace(atob(redirectDoc))
        return
      }

      history.replace('/')
    } catch (error) {
      // a spent token: the calm card; a sign-in auth holds for link
      // confirmation (403 link_confirmation_required): its page; anything
      // else: the "didn't work" card
      if (onSpent(error)) return
      if (sendToLinkConfirmation(error, token)) return
      updateFailed(error || {})
    }
  }, [])

  if (spent) {
    return <SignInLinkSpent reason={spent} />
  }

  if (failed) {
    return <SignInLinkFailed error={failed} />
  }

  return <React.Fragment />
}
